import { FunnelMonitoringPage } from '@/modules/tracking/funnel/funnel-tracking-page'

export const FunnelMonitoringView = () => {
  return <FunnelMonitoringPage />
}
